import {
  CITATION_LIST_NAME_LOWER_PLURAL,
  CITATION_LIST_NAME_LOWER_SINGLE,
} from '@chegg-wt/core/constants/citations'

export const DELETE_PROJECT_MODAL_TITLE_SINGLE = `Delete ${CITATION_LIST_NAME_LOWER_SINGLE}`
export const DELETE_PROJECT_MODAL_TITLE_MULTIPLE = (numberOfProjects) =>
  `Delete ${numberOfProjects} ${CITATION_LIST_NAME_LOWER_PLURAL}`
export const DELETE_PROJECT_MODAL_DESC_SINGLE = `Citations in this ${CITATION_LIST_NAME_LOWER_SINGLE} will also be permanently deleted.`
export const DELETE_PROJECT_MODAL_DESC_MULTIPLE = `Citations in these ${CITATION_LIST_NAME_LOWER_PLURAL} will also be permanently deleted.`

export const DELETE_PROJECT_MODAL_ID = 'delete-project-modal'
